import { useState } from "react";

function useProvideAuth() {

  // *For User
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [userDetail, setUserDetail] = useState(JSON.parse(localStorage.getItem('userDetail')));

  // *For Login
  const userLogin = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
  };

  // *For User Detail
  const saveUserDetail = (data) => {
    localStorage.setItem('userDetail', JSON.stringify(data))
    setUserDetail(data)
  };

  // *For Logout
  const userLogout = async () => {
    setUser(null)
    localStorage.clear()
  };

  return {
    user,
    userDetail,
    userLogin,
    userLogout,
    saveUserDetail
  };
}

export default useProvideAuth;